import React from 'react';
import palette from './palette';

interface JobDetailsTableProps {
  caption?: string;
  // Rows of <th scope="row">label</th><td>value</td>.
  children: React.ReactNode;
}

// One rounded frame like the status alert above it: rows ruled, no column
// rule, labels muted so the values stand out.
const styles = `
  .job-details {
    margin-bottom: 20px;
    overflow: hidden;
    border: 1px solid ${palette.border};
    border-radius: 4px;
  }
  .job-details table {
    width: 100%;
    margin: 0;
    border-collapse: collapse;
    font-size: 13px;
  }
  .job-details caption {
    padding: 8px 12px;
    border-bottom: 1px solid ${palette.border};
    background: ${palette.panelBackground};
    color: ${palette.heading};
    font-weight: 700;
    text-align: left;
  }
  .job-details th,
  .job-details td {
    padding: 7px 12px;
    text-align: left;
    vertical-align: top;
  }
  .job-details tr + tr th,
  .job-details tr + tr td {
    border-top: 1px solid ${palette.border};
  }
  .job-details th {
    width: 34%;
    color: ${palette.muted};
    font-weight: 400;
  }
  .job-details td { word-break: break-word; }
`;

function JobDetailsTable({
  caption,
  children,
}: JobDetailsTableProps): JSX.Element {
  return (
    <div className="job-details">
      <style>{styles}</style>
      <table>
        {caption && <caption>{caption}</caption>}
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

export default JobDetailsTable;
